/**
 * Class that runs through the passed array
 * of validation rules
 */
export default class Validator {
	/**
	 * @param {string} key
	 * @param {Array} validation rules - output from a 'Rules' chain
	 */
	constructor(key = '', validationRules) {
		this.key = key;
		this.validationRules = validationRules;
	}
	/**
	 * Valiates the passed value against the passed
	 * 'validation rules'
	 * @param {string|number} value
	 * @returns {Array} of validation messages
	 */
	validate(value) {
		var messages = [];
		this.validationRules.every((validationRule) => {
			var validationResult = validationRule(value);
			if (!validationResult.isValid) {
				messages.push({
					key: validationResult.message,
					messageTemplateValues: '',
				});
				return !validationResult.endAllIfInvalid;
			} else {
				return true;
			}
		});
		return messages;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/validation/Validator.js